import {Locale} from '@aboutyou/config';

export type DateFormatLong =
  | 'dd.mm.yyyy'
  | 'mm.dd.yyyy'
  | 'yyyy.dd.mm'
  | 'yyyy.mm.dd'
  | 'yyyy-mm-dd'
  | 'dd-mm-yyyy'
  | 'dd/mm/yyyy';

export function getLongDateFormatForLocale_UNSAFE(locale: Locale) {
  return countryDateSpecifics[locale];
}

const countryDateSpecifics: {[locale in Locale]: DateFormatLong} = {
  [Locale.en_ZZ]: 'yyyy-mm-dd',
  [Locale.es_ZZ]: 'yyyy-mm-dd',
  [Locale.de_DE]: 'dd.mm.yyyy',
  [Locale.en_DE]: 'dd.mm.yyyy',
  [Locale.de_AT]: 'dd.mm.yyyy',
  [Locale.en_AT]: 'dd.mm.yyyy',
  [Locale.de_CH]: 'dd.mm.yyyy',
  [Locale.fr_CH]: 'dd.mm.yyyy',
  [Locale.it_CH]: 'dd.mm.yyyy',
  [Locale.en_CH]: 'dd.mm.yyyy',
  [Locale.nl_NL]: 'dd-mm-yyyy',
  [Locale.en_NL]: 'dd-mm-yyyy',
  [Locale.pl_PL]: 'dd.mm.yyyy',
  [Locale.nl_BE]: 'dd/mm/yyyy',
  [Locale.fr_BE]: 'dd/mm/yyyy',
  [Locale.cs_CZ]: 'dd.mm.yyyy',
  [Locale.sk_SK]: 'dd.mm.yyyy',
  [Locale.hu_HU]: 'yyyy.mm.dd',
  [Locale.ro_RO]: 'dd.mm.yyyy',
  [Locale.sl_SI]: 'dd.mm.yyyy',
  [Locale.lv_LV]: 'dd.mm.yyyy',
  [Locale.ru_LV]: 'dd.mm.yyyy',
  [Locale.lt_LT]: 'yyyy-mm-dd',
  [Locale.et_EE]: 'dd.mm.yyyy',
  [Locale.ru_EE]: 'dd.mm.yyyy',
  [Locale.hr_HR]: 'dd.mm.yyyy',
  [Locale.bg_BG]: 'dd.mm.yyyy',
  [Locale.fr_FR]: 'dd/mm/yyyy',
  [Locale.da_DK]: 'dd.mm.yyyy',
  [Locale.sv_SE]: 'yyyy-mm-dd',
  [Locale.fi_FI]: 'dd.mm.yyyy',
  [Locale.es_ES]: 'dd/mm/yyyy',
  [Locale.it_IT]: 'dd/mm/yyyy',
  [Locale.pt_PT]: 'dd/mm/yyyy',
  [Locale.el_GR]: 'dd/mm/yyyy',
  [Locale.el_CY]: 'dd/mm/yyyy',
  [Locale.fr_LU]: 'dd/mm/yyyy',
};
